const styles = {
  1: {
    display: { sm: "flex" },
    padding: { sm: "48px 74px" },
    paddingLeft: { sm: "68px" },
    justifyContent: "space-between",
    margin: "auto 0",
  },
  2: {
    margin: { xs: "0", sm: "0 80px" },
    marginLeft: { xs: "55px" },
    rowGap: { xs: "40px", sm: "60px" },
    marginTop: { xs: "10px" },
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  3: {
    width: "200vw",
  },
  4: {
    width: 264,
    height: 336,
    boxShadow: "0px 0px 7px 2px rgba(0, 0, 0, 0.0294384)",
  },
  5: {
    fontSize: "18px",
    fontWeight: "800",
    marginX: "12.5px",
    marginY: "11px",
  },
  6: {
    marginX: "12.5px",
  },
  7: {
    margin: { xs: "30px 17px", sm: "40px 80px" },
  },
  8: {
    borderRadius: "6px",
    boxShadow: "0px 0px 7px rgba(0, 0, 0, 0.293139)",
    marginBottom: "50px",
  },
  9: {
    flexDirection: { xs: "column", sm: "row" },
    columnGap: "2rem",
    display: "flex",
  },
  10: {
    maxWidth: { sm: "40vw" },
    minWidth: { xs: "70vw", sm: "40vw", md: "40vw" },
    width: "100%",
    height: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    flexGrow: "2",
    mr: { xs: 0, sm: "-50px", md: 0 },
    // mr: "0px",
  },
  11: {
    paddingY: { xs: "1rem", sm: "5rem" },
    height: { xs: "50vh", sm: "100%" },
    justifyContent: { xs: "flex-start", sm: "flex-end" },
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  12: {
    justifyContent: { sm: "space-between" },
    width: { sm: "80%" },
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  13: {
    fontSize: { xs: "24px", sm: "32px" },
    fontWeight: "800",
    marginY: "1rem",
  },
  14: {
    display: { sm: "flex" },
    justifyContent: { sm: "space-between" },
  },
  15: {
    marginBottom: { xs: "25px" },
  },
  16: {
    width: { xs: "93vw", sm: "95%" },
    marginBottom: { xs: "1.5rem", sm: "0" },
    marginTop: { sm: "23px" },
    m: 1,
    minWidth: 220,
    color: "blue",
  },
  17: {
    padding: { xs: "6px 0", sm: "8px 60px" },
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.0562443)",
    marginBottom: "0px",
  },
  18: {
    marginTop: { xs: "11px" },
    fontSize: { xs: "16px", sm: "24px" },
    flexGrow: 1,
    fontWeight: "800",
    padding: "0",
    height: "100%",
  },
  19: {
    fontSize: { xs: "12px", sm: "16px" },
    marginTop: { xs: "9px" },
    fontWeight: "600",
  },
  20: {
    transform: "scale(0.7)",
  },
  21: {
    width: { xs: "91vw", sm: "480px" },
    minWidth: { sm: "200px" },
    marginLeft: { xs: "11px" },
    marginY: "25px",
  },
  22: {
    display: "inline-block",
  },
  23: {
    display: { xs: "block", sm: "inline-block" },
  },
  24: {
    width: "100%",
    height: "30vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};

export default styles;
